export default defineNuxtRouteMiddleware((to) => {
    // Check if the query parameter exists
        if(to.query.session_id){
            return navigateTo({
                path:'/resetpassword',
                query:{
                    session:to.query.session_id
                },
            });
        }

  });